import React, {useState, useEffect} from 'react';
import {url, history} from '../../utils/variables';
import {pexios, uploadImages, hardCopy} from '../../utils/functions';
import {useDispatch, useSelector} from 'react-redux';
import {setRouterData} from '../../redux/actions';
import UploadCoroukieImages from '../../components/pages/complete/UploadCoroukieImages';
import UploadDocs from '../../components/pages/complete/UploadDocs';
import UploadCarImage from '../../components/pages/complete/UploadCarImages';
import UploadCrashImage from '../../components/pages/complete/UploadCrashImage'
import Moment from 'moment-jalaali';
import Maps from '../../components/pages/complete/Maps';
import EventBus from '../../components/master/eventBus';
import Timer from '../../components/master/Timer';
import defaultProfile from '../../assets/images/default_profile.png';
import UploadDamageImage from '../../components/pages/complete/UploadDamageImage'
import { useTranslation } from 'react-i18next';

export default function Complete() {
    const { t } = useTranslation();
    const {id} = useSelector((store) => store.routerData);
    const dispatch = useDispatch();

    const [accident, setAccident] = useState({
        attachments: [],
        losses: [],
    });
    const [step, setStep] = useState(null);
    const [expert, setExpert] = useState({});
    const [callPermit, setCallPermit] = useState(false);


    useEffect(() => {
        id && pexios('/api/v2/get_accident', 'post', {accident_id: id , type :'complete'})
            .then(res => {
                setAccident(res.data.data);
                setStep(res.data.data.has_coroukie ? 0 : 1)
            });
    }, [id]);

    function changeStep(step) {
        setStep(step);
        const element = document.getElementById(`step${step}`);
        setTimeout(() => element.scrollIntoView());
    }

    function broadcast(data) {
        const content = data.message;
        if (parseInt(content.accident_id) === id) {
            if (content.message === 'expert_to_accident') {
                pexios('/api/v2/get_expert', 'post', {expert_id: content.expert_id})
                    .then(res => {
                        setExpert(res.data.data);
                        setStep(6);
                        ///it has to be 7
                    });
            }
            if (content.message === 'expert_arrived') {
                dispatch(setRouterData({}));
                history.push(`/success/${id}`);
            }
            if (content.message === 'approve_accident') {
                setStep(1);
            }
        }
    }

    function defineStepClass(id) {
        let className = 'c-parent';
        if (step === id) className = 'c-parent active';
        if (step > id) className = 'c-parent done';
        return className;
    }

    function uploadDoc(image, name, done) {
        let attachments = hardCopy(accident.attachments);
        const index = attachments.findIndex(img => img.filename === name);
        uploadImages({
            id,
            type: 'accident',
            name,
            image,
            done,
            callback: (data) => {
                if (index !== -1) attachments[index] = data;
                else attachments.push(data);
                setAccident(prevState => ({
                    ...prevState,
                    attachments,
                }));
            },
        });
    }

    function finish(location) {
        const data = {
            lat: location.lat,
            lng: location.lng,
            accident_id: id,
        };
        pexios('api/update_accident_photos', 'post', data)
            .then(() => {
                if (accident.request_expert === 0) {
                    dispatch(setRouterData({}));
                    history.push(`/success/${id}`);
                } else setStep(6);
            });
    }

    return (
        <div className='content complete'>
            <EventBus onEvent={broadcast}/>
            <div className='pt50 pb50'>
                <div className='c-parent done'>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-car-crash'/>
                        </div>
                        <div className='title-text'>
                            
                                 { t('Accident notification in the hour')}{ accident && Moment(accident.created_at).format('HH:mm')}
                            
                        </div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'/>
                    </div>
                </div>
                <div className='c-parent done'>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-headset'/>
                        </div>
                        <div className='title-text'>{t('Call and confirm the accident by the headquarters')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'/>
                    </div>
                </div>
                {
                    !!accident.has_coroukie &&
                    <div id='step0' className={defineStepClass(0)}>
                        <div className='title-box'>
                            <div className='icon-box'>
                                <i className='fas fa-paste'/>
                            </div>
                            <div className='title-text'>{step === 0 && t('Waiting')} {t('Send accident image report')}</div>
                        </div>
                        <div className='content-parent'>
                            <div className='content-box'>
                                {
                                    step === 0 &&
                                    <UploadCoroukieImages
                                        attachments={accident.attachments}
                                        changeStep={changeStep}
                                        uploadDoc={uploadDoc}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                }
                <div id='step1' className={defineStepClass(1)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-cloud-upload-alt'/>
                        </div>
                        <div className='title-text'>{step === 1 && t('Waiting')} {t('Send image documents')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 1 &&
                                <UploadDocs
                                    attachments={accident.attachments}
                                    insuranceType={accident.insurance_type}
                                    losses={accident.losses}
                                    hasCoroukie={accident.has_coroukie}
                                    changeStep={changeStep}
                                    uploadDoc={uploadDoc}
                                />
                            }
                        </div>
                    </div>
                </div>
                <div id='step2' className={defineStepClass(2)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-car'/>
                        </div>
                        <div className='title-text'>{step === 2 && t('Waiting')} {t('Send vehicle image')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 2 &&
                                <UploadCarImage
                                    insuranceType={accident.insurance_type}
                                    attachments={accident.attachments}
                                    losses={accident.losses}
                                    changeStep={changeStep}
                                    uploadDoc={uploadDoc}
                                />
                            }
                        </div>
                    </div>
                </div>
                <div id='step3' className={defineStepClass(3)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-car-crash'/>
                        </div>
                        <div className='title-text'>{step === 3 && t('Waiting')} {t('Sending positions and damaged parts')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 3 &&
                                // <UploadCrashImages
                                //     attachments={accident.attachments}
                                //     changeStep={changeStep}
                                //     uploadDoc={uploadDoc}
                                // />
                                <UploadCrashImage
                                    losses={accident.losses}
                                    attachments={accident.attachments}
                                    changeStep={changeStep}
                                    uploadDoc={uploadDoc}
                                    insuranceType={accident.insurance_type}
                                />
                            }
                        </div>
                    </div>
                </div>
                <div id='step4' className={defineStepClass(4)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-car-crash'/>
                        </div>
                        <div className='title-text'>{step === 4 && t('Waiting')} {t('Send accident image')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 4 &&
                                <UploadDamageImage
                                    attachments={accident.attachments}
                                    changeStep={changeStep}
                                    uploadDoc={uploadDoc}
                                />
                                
                            }
                        </div>
                    </div>
                </div>
                <div id='step5' className={defineStepClass(5)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='far fa-compass'/>
                        </div>
                        <div className='title-text'>{step === 5 && t('Waiting')} {t('Select position in map')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 5 &&
                                <Maps
                                    changeStep={changeStep}
                                    onFinish={finish}
                                />
                            }
                        </div>
                    </div>
                </div>
                <div id='step6' className={defineStepClass(6)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-user'/>
                        </div>
                        <div className='title-text'>{step === 6 && t('Waiting')} {t('Expert assignment')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 6 &&
                                <div className='complete-content text-center'>
                                    <p>{t('Waiting for expert assignment')}</p>
                                    <p>{t('Thanks for your patiance')}</p>
                                    <i className='fas fa-spinner fa-spin mt10'
                                       style={{color: '#30bfc7', fontSize: 30}}/>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div id='step7' className={defineStepClass(7)}>
                    <div className='title-box'>
                        <div className='icon-box'>
                            <i className='fas fa-shipping-fast'/>
                        </div>
                        <div className='title-text'>{step === 7 && t('Waiting')} {t('Dispatch Expert')}</div>
                    </div>
                    <div className='content-parent'>
                        <div className='content-box'>
                            {
                                step === 7 &&
                                <div className='complete-content text-center'>
                                    <p>{t('Expert info')}:</p>
                                    <div className='mt20'>
                                        <img
                                            src={
                                                expert.avatar ?
                                                    `${url}/files?uid=${expert.avatar.uid}&width=200&height=200` :
                                                    defaultProfile
                                            }
                                            alt='profile'
                                            className='profile-pic'
                                        />
                                    </div>
                                    <p className='mt10'>{expert.fname} {expert.lname}</p>
                                    <Timer seconds={300} onFinish={() => setCallPermit(true)}/>
                                    <div className='expert-button-parent mt10'>
                                        <div className='flex1 text-center pr5'>
                                            <a className='btn btn-green btn-sm btn-block btn-circle'
                                               href={`tel:${expert.mobile}`}>
                                                {t('Contact with expert')}
                                            </a>
                                        </div>
                                        {
                                            callPermit &&
                                            <div className='flex1 text-center pl5'>
                                                <a className='btn btn-red btn-sm btn-block'
                                                   href='tel:02191065151'>{t('Contact with company')}</a>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}
